import { render, staticRenderFns } from "./HeaderPromotion.vue?vue&type=template&id=50cdf3ec&scoped=true"
import script from "./HeaderPromotion.vue?vue&type=script&lang=ts"
export * from "./HeaderPromotion.vue?vue&type=script&lang=ts"
import style0 from "./HeaderPromotion.vue?vue&type=style&index=0&id=50cdf3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cdf3ec",
  null
  
)

export default component.exports